jQuery(function ($) {
  var $sliderContainer = $(".trustpilot-slider-wrapper");
  var $slider = $sliderContainer.find(".trustpilot-slider");

  // Initialize Slick slider
  if ($slider.length && !$slider.hasClass("slick-initialized")) {
    $slider.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: $sliderContainer.find(
        ".trustpilot-slider-controls .slider-prev",
      ),
      nextArrow: $sliderContainer.find(
        ".trustpilot-slider-controls .slider-next",
      ),
      dots: false,
      infinite: false,
      autoplay: false,
      adaptiveHeight: false,
      centerMode: false,
      variableWidth: false,
      spaceBetween: 0,
      responsive: [
        {
          breakpoint: 3200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.2,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.2,
            dots: true,
            arrows: false,
          },
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 1.17,
            dots: true,
            arrows: false,
          },
        },
      ],
    });
  }
  // Responsive behavior
  $(window).on("resize", function () {
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("resize");
    }
  });
});

const playButtons = document.querySelectorAll(
  ".trustpilot-slider-section .js-play-video",
);

if (playButtons.length) {
  playButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const video = button.nextElementSibling;
      if (video && video.tagName === "VIDEO") {
        video.play();
      }
    });
  });
}

// Add event listeners to videos in testimonial cards
const testimonialVideos = document.querySelectorAll(".testimonial-card video");

if (testimonialVideos.length) {
  testimonialVideos.forEach((video) => {
    video.addEventListener("play", () => {
      // Show controls when video starts playing
      video.setAttribute("controls", "controls");

      // Find and hide the associated play button
      const playButton = video.previousElementSibling;
      if (playButton && playButton.classList.contains("js-play-video")) {
        playButton.style.display = "none";
      }
    });
  });
}

class AudioMedia extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.toggleAudio.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.playButton = this.querySelector('.js-play-audio');
    this.audioElement = this.querySelector('audio');

    if (!this.playButton || !this.audioElement) return;

    this.playButton.removeEventListener('click', this.handleClick);
    this.playButton.addEventListener('click', this.handleClick);

    this.audioElement.addEventListener('ended', () => {
      this.classList.remove('active');
    });
  }

  toggleAudio() {
    if (this.audioElement.paused) {
      this.audioElement.play();
      this.classList.add('active');
    } else {
      this.audioElement.pause();
      this.classList.remove('active');
    }
  }
}

customElements.define('audio-media', AudioMedia);